import React, { useEffect, useState } from "react";
import "./DynamicTextInput.css";

const DynamicTextInput = ({
	name,
	id,
	value,
	array,
	className,
	checkErrors,
	updateResult,
	annCost,
	readonly,
	...props
}) => {
	const [val, setVal] = useState(value);

	useEffect(() => {
		function setValue() {
			if (readonly === true) {
				setVal((annCost / 12).toFixed(2));
				array[id].value = (annCost / 12).toFixed(2);
				updateResult();
			}
		}

		setValue();
		return () => {};
	}, [annCost]);

	return (
		<>
			<h4 className="mr-auto font-medium">{name}</h4>
			<input
				className={`TextInput ${className}`}
				style={{ maxWidth: "520px" }}
				name={name}
				id={id}
				value={val}
				onChange={(e) => {
					setVal(e.target.value);
					array[id].value = e.target.value;
					updateResult();
				}}
				readOnly={readonly}
				{...props}
			/>
			{checkErrors && val === "" && (
				<p className="error-text text-left text-sm">
					{"* this field cannot be empty"}
				</p>
			)}
		</>
	);
};

export default DynamicTextInput;
